import {Component, OnInit, Input, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnInit {

  @Input() content: string;
  @Input() limit: number;
  @Input() completeWords: boolean;

  isContentToggled: boolean;
  nonEditedContent: string;
  needMore: boolean;
  lessContent = '';

  constructor() {

  }

  ngOnInit() {
    this.nonEditedContent = this.content;
    this.needMore = this.content.length > this.limit;

    if (this.needMore) {
      this.limit = this.content.substring(0, this.limit).lastIndexOf(' ');
      this.content = this.lessContent = this.formatContent(this.content);
    }
  }

  toggleContent() {
    this.isContentToggled = !this.isContentToggled;
    this.content = this.isContentToggled ? this.nonEditedContent : this.lessContent;
  }

  formatContent(content: string) {
    if (!this.needMore) {
      return content;
    }

    return `${content.substring(0, this.limit)}...`;
  }

}

